import React, {useContext, useState} from "react";
import DetailsComponent from "./DetailsComponent";
import {CardOffer, ItemName} from "../../../styles/Offer";
import {TypeTitle, ContentContainer} from "../../../styles/Products";
import styled from "styled-components";
import Color from "../../../assets/Colors";
import {Link, useLocation} from "react-router-dom";
import {Content} from "../../../styles/GlobalStyles";
import {CoursesContext} from "../../../context/CoursesContext";
import {LoadComponet} from "../../../components/loaders/Loader";
// import VideoThumbnail from "react-video-thumbnail"; // use npm published version
import VideoModal from "../../modals/VideoModal";

export default function MediaSection({courseType}) {
   let location = useLocation();
   const {mediaCourse} = useContext(CoursesContext);
   const [currentVideo, setVideo] = useState("");

   if (mediaCourse.isLoading) return <LoadComponet />;

   if (mediaCourse.data.length > 0) {
      return (
         <DetailsComponent
            column={true}
            title="CÁpsulas de video"
            titleClass="centerDesk"
            iconTitle={require(".././../../assets/icons/media.png")}
            iconClass="min"
         >
            <Content>
               <ContentContainer>
                  <ItemsContainer>
                     {React.Children.toArray(
                        mediaCourse.data.map((item) => {
                           return (
                              <ItemStyle key={item.idResource} sizeL={mediaCourse.data.length}>
                                 {/*  <VideoThumbnail
                                    videoUrl={`http://domecqapi.trebolbit.com/${item.pathResource}`}
                                    thumbnailHandler={(thumbnail) => console.log(thumbnail)}
                                    /* width={120}
                                 height={80} 
                                    alt="course_img"
                                    className="img"
                                 /> */}
                                 <img
                                    src={"http://domecqapi.trebolbit.com/media/courses/web/mobile/1586300559661.jpg"}
                                    alt="course_img"
                                    className="img"
                                 />
                                 <WhiteCard paddBottom="0">
                                    <img src={require("../../../assets/icons/esencial.png")} className="iconDot" alt="dot" />
                                    <TypeTitle>{typeVideo(courseType)}</TypeTitle>
                                    <ItemName>{item.resourceName}</ItemName>
                                    <ActionBio to={`${location.pathname}?courseMedia=true`} onClick={() => setVideo(item.pathResource)}>
                                       <span>Ver video</span>
                                       <img src={require(".././../../assets/icons/media.png")} alt="next" className="mediaIcon" />
                                    </ActionBio>
                                 </WhiteCard>
                              </ItemStyle>
                           );
                        }),
                     )}
                     <VideoModal videoUrl={currentVideo} initiator="courseMedia" />
                  </ItemsContainer>
               </ContentContainer>
            </Content>
         </DetailsComponent>
      );
   }
   return null;
}

const typeVideo = (id) => {
   switch (id) {
      case 1:
         return "Cursos esenciales";
      case 2:
         return "Certificado Prime";
      case 3:
         return "Certificado Prime";
      case 5:
         return "Masterclass";
      default:
         return "Cursos Domecq";
   }
};

const ActionBio = styled(Link)`
   font-weight: 300;
   color: ${Color.secondary};
   font-size: 1.2em;
   line-height: 1.4em;
   margin-top: 1.5em;

   display: flex;
   align-items: center;

   & .mediaIcon {
      width: 1em;
      height: 1em;
      margin-left: 0.5em;
      margin-top: 3px;
   }
   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
      line-height: 1.2em;
      margin-top: 1.5em;
   }
`;

const ItemStyle = styled.div`
   width: 24.5%;
   margin-right: 0.5%;

   &:nth-child(4n) {
      margin-right: 0;
   }

   &:nth-child(-n + ${(props) => props.sizeL - (props.sizeL % 4)}) {
      margin-bottom: 3em;
   }

   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   align-items: center;
   & img {
      width: 100%;
   }

   & ${TypeTitle} {
      font-size: 0.9em;
   }
   & ${ItemName} {
      font-size: 0.8em;
   }
`;

const ItemsContainer = styled.div`
   width: 100%;
   display: flex;
   justify-content: center;
   flex-wrap: wrap;
   @media screen and (max-width: 600px) {
      & ${ItemStyle} {
         width: 100%;
         margin-right: 0;
      }
   }
`;

const WhiteCard = styled(CardOffer)`
   padding-bottom: 0.5em;
   margin-top: -6em;
`;
